import { defineMessages } from "react-intl"

const messages = defineMessages({
  shareOrUse: {
    id: "share.share-or-use",
    defaultMessage: "Share or use this image"
  },
  beforeSharing: {
    id: "share.before-sharing",
    defaultMessage:
      "Before sharing or using this media it's worth noting the rights:"
  },
  download: {
    id: "share.button-download",
    defaultMessage: "Download"
  },
  downloadSize: {
    id: "share.button-download-size",
    defaultMessage:
      "Download {size, select, small {Small} large {Large} original {Original} } JPG"
  },
  addToSet: {
    id: "share.add-to-set",
    defaultMessage: "Add to a set"
  },
  addRemoveFromSet: {
    id: "share.add-remove-from-set",
    defaultMessage: "Add/Remove from a set"
  },
  shareFacebook: {
    id: "share.facebook",
    defaultMessage: "Share this item on Facebook"
  },
  shareTwitter: {
    id: "share.teitter",
    defaultMessage: "Share this item on Twitter"
  },
  shareEmail: {
    id: "share.email",
    defaultMessage: "Email this item"
  },
  sharePinterest: {
    id: "share.pinterest",
    defaultMessage: "Share this item on Pinterest"
  },
  share: {
    id: "share",
    defaultMessage: "Share"
  },
  downloadAudio: {
    id: "download.audio-file",
    defaultMessage: "Audio File"
  },
  downloadEntireItem: {
    id: "download.entire-item",
    defaultMessage: "Entire item"
  },
  downloadLowQuality: {
    id: "download.low-quality",
    defaultMessage: "Low Quality"
  },
  downloadHighQuality: {
    id: "download.high-quality",
    defaultMessage: "High Quality"
  }
})

export default messages



// WEBPACK FOOTER //
// ./webapp/messages/share.js